import { type ComponentProps } from 'react';

import {
	Popover as ArkPopover,
	type PopoverRootProps as ArkPopoverRootProps,
	Portal
} from '@ark-ui/react';

import { cn } from '../../lib/utils';

type PopoverRootProps = ArkPopoverRootProps;

function PopoverRoot({ lazyMount = true, unmountOnExit = true, ...props }: PopoverRootProps) {
	return <ArkPopover.Root lazyMount={lazyMount} unmountOnExit={unmountOnExit} {...props} />;
}

function PopoverTrigger({ className, ...props }: ComponentProps<typeof ArkPopover.Trigger>) {
	return <ArkPopover.Trigger className={className} {...props} />;
}

function PopoverContent({ className, ...props }: ComponentProps<typeof ArkPopover.Content>) {
	return (
		<Portal>
			<ArkPopover.Positioner className="pt-popover-positioner">
				<ArkPopover.Content className={cn('pt-popover-content', className)} {...props} />
			</ArkPopover.Positioner>
		</Portal>
	);
}

function PopoverTitle({ className, ...props }: ComponentProps<typeof ArkPopover.Title>) {
	return <ArkPopover.Title className={cn('pt-popover-title', className)} {...props} />;
}

function PopoverDescription({
	className,
	...props
}: ComponentProps<typeof ArkPopover.Description>) {
	return <ArkPopover.Description className={cn('pt-popover-description', className)} {...props} />;
}

function PopoverClose({ className, ...props }: ComponentProps<typeof ArkPopover.CloseTrigger>) {
	return <ArkPopover.CloseTrigger className={cn('pt-popover-close', className)} {...props} />;
}

function PopoverArrow({ className, ...props }: ComponentProps<typeof ArkPopover.Arrow>) {
	return (
		<ArkPopover.Arrow className={className} {...props}>
			<ArkPopover.ArrowTip />
		</ArkPopover.Arrow>
	);
}

const Popover = Object.assign(PopoverRoot, {
	Root: PopoverRoot,
	Trigger: PopoverTrigger,
	Content: PopoverContent,
	Title: PopoverTitle,
	Description: PopoverDescription,
	Close: PopoverClose,
	Arrow: PopoverArrow
});

export { Popover, type PopoverRootProps };
